/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */
import { DashboardTemplate, GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { DashboardTemplateId } from '@shared/types/monitoring';

export const dashboardTemplates = createAction(
  '[Dashboard] Dashboard templates',
  props<{ dashboardTemplates: DashboardTemplate[] }>(),
);

export const getDashboardTemplates = createAction('[Dashboard] Dashboard templates get');
export const getDashboardTemplatesError = createAction('[Dashboard] Dashboard templates get error', props<GmcError>());

export const saveDashboardAsTemplate = createAction(
  '[Dashboard] Save dashboard as template',
  props<{ dashboardId: string }>(),
);
export const saveDashboardTemplate = createAction(
  '[Dashboard] Save dashboard template',
  props<{ dashboardTemplate: Omit<DashboardTemplate, 'id'> }>(),
);
export const saveDashboardTemplateOk = createAction(
  '[Dashboard] Save dashboard template OK',
  props<{
    dashboardTemplate: DashboardTemplate;
    notification?: string;
  }>(),
);
export const saveDashboardTemplateErr = createAction('[Dashboard] Save as template err', props<GmcError>());

export const renameDasboardTemplateIntent = createAction(
  '[Dashboard template] Rename intent',
  props<{ dashboardTemplateId: DashboardTemplateId; currentName: string }>(),
);
export const renameDashboardTemplate = createAction(
  '[Dashboard template] Rename',
  props<{ dashboardTemplateId: DashboardTemplateId; name: string }>(),
);
export const renameDashboardTemplateOk = createAction(
  '[Dashboard template] Rename OK',
  props<{ dashboardTemplateId: DashboardTemplateId; name: string; notification?: string }>(),
);
export const renameDashboardTemplateErr = createAction('[Dashboard template] Rename err', props<GmcError>());

export const removeDashboardTemplate = createAction(
  '[Dashboard template] Remove',
  props<{ dashboardTemplateId: DashboardTemplateId }>(),
);
export const removeDashboardTemplateOk = createAction(
  '[Dashboard template] Remove OK',
  props<{ dashboardTemplateId: DashboardTemplateId; notification?: string }>(),
);
export const removeDashboardTemplateErr = createAction('[Dashboard template] Remove err', props<GmcError>());

export const dashboardsEnter = createAction('[Dashboard] Enter dashboards page');
export const dashboardsLeave = createAction('[Dashboard] Leave dashboards page');
